/**
 * body要素にpageNamesに含まれるクラスがついているか判定
 * @param {string[]|string} pageNames
 * @returns {boolean}
 */
export function isPage(...pageNames) {
  return pageNames.some((pageName) => document.body.classList.contains(pageName));
}
